export default function pieceColor(str) {
  return str[0] === 'b' ? "black" : "white";
}
